export default "__VITE_ASSET__BVAUuuGW__"